import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

interface SocialMediaVaProtectedRouteProps {
  children: ReactNode;
}

export function SocialMediaVaProtectedRoute({ children }: SocialMediaVaProtectedRouteProps) {
  const { user, userRole, userRoleData, isLoading } = useAuth();

  if (isLoading || (user && userRole === null)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  const isSocialMediaVa = userRole === "employee" && userRoleData?.employee_type === "social_media_va";
  const isAdmin = userRole === "admin";

  if (!isSocialMediaVa && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
